module.exports = __webpack_public_path__ + "img/aeiou_2.aa4276a3.png";